<template>
	<EMCoreTemplate category="OSMLife" identity="outstandingRequirement" entity="osm_outstanding_req"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementLife/containers/OutstandingRequirement.vue